import { useState, useEffect } from 'react';
import Button from 'olive-react-myoneui/lib/Button';
import { boxOIcon } from '../../constants/icons';
import { Route, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setCart } from '../../reducers/cartSlice';
import {
  documents,
  infinityIcon,
  globeIcon,
  chatIcon,
  awardIcon,
} from '../../constants/icons';
import AddToCartButton from "./AddToCartButton";
import EnrollNowButton from './EnrollNowButton';

function AddToCartVerticalBundle({ className, coursedetails }) {
  let allLeactureCount = 0;

  coursedetails?.course_details.map(
    (item, i) => (allLeactureCount += item.lecture_count)
  );

  const paths = useSelector((state) => state.user.paths);
  let defaultImage = paths.default_bundle;
  let imagePath = paths.bundle_path + coursedetails?.bundle.c_image;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const miscellaneous = useSelector((state) => state.user.miscellaneous);
  const loggedInUser = useSelector((state) => state.user.user);

  const shopping_cart = miscellaneous.shopping_cart;
  const [carttext, setCartText] = useState('');
  const [newbutton, setNewbutton] = useState('');

  useEffect(() => {
    let id = coursedetails?.bundle_id;
    let cart = localStorage.getItem('mycart');
    cart = JSON.parse(cart);
    if (id) {
      id = 'bundle_' + id;
      if (cart != null) {
        if (typeof cart[id] != 'undefined') {
          setCartText(true);
        } else {
          setCartText(false);
        }
      } else {
        setCartText(false);
      }
    }
  }, [coursedetails]);

  useEffect(() => {
    if (!carttext) {
      setNewbutton(
        <Button
          variant="outline"
          className="w-100 mb-3"
          size="md"
          disabled
          onClick={() => addToCartFn(false, coursedetails?.bundle_id, 'bundle')}
        >
          Add to cart
        </Button>
      );
    } else {
      setNewbutton(
        <Button
          variant="secondary"
          className="w-100 mb-3"
          size="md"
          onClick={() => navigate('/cart_react')}
        >
          Go To Cart
        </Button>
      );
    }
  }, [carttext]);

  const current_price_fn = () => {
    let current_price =
      coursedetails?.bundle.c_discount_percent > 0
      ? coursedetails.bundle.c_discount
      : (coursedetails?.bundle.c_discount > 0
          ? coursedetails.bundle.c_discount
          : coursedetails?.bundle.c_price);
    return coursedetails?.current_currency.symbol + current_price;
  };

  const discount_price_fn = () => {
    let orginal_price = 0;
    if (
      coursedetails?.bundle.c_is_free != 1 &&
      coursedetails?.bundle.c_discount > 1
    ) {
      orginal_price = 1;
      return (
        coursedetails?.current_currency.symbol + coursedetails?.bundle.c_price
      );
    }
  };

  const member_price_fn = () => {
    if (coursedetails?.bundle.c_member_status == 1) {
      return (
        coursedetails?.current_currency.symbol +
        coursedetails?.bundle.c_member_price
      );
    }
  };

  const postFormDataAsJson = (apiCall, formData) => {
    const formDataJsonString = JSON.stringify(formData);
    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },

      body: formDataJsonString,
    };
    const response = fetch(apiCall, fetchOptions);
    setCartText(true);
    // if (!response.ok) {
    // 	const errorMessage =  response.text();
    // 	throw new Error(errorMessage);
    // }
    // return response.json();
  };

  const addToCartFn = (
    item = false,
    id,
    item_type,
    learners = {},
    other = {}
  ) => {
    if (localStorage.getItem('mycart') == '[]')
      localStorage.setItem('mycart', '{}');
    var cart =
      localStorage.getItem('mycart') != null
        ? JSON.parse(localStorage.getItem('mycart'))
        : {};
    var oncart = true;
    var index = item_type + '_' + id;

    if (!cart[index]) {
      cart[index] = {
        id: id,
        type: item_type,
        learners: learners,
        metadata: {},
        other: other,
      };
      var cart_temp = cart[index];
      var cart_count = Object.keys(cart).length;
      cart = JSON.stringify(cart);
      localStorage.setItem('mycart', cart);
      localStorage.setItem('mycart_count', cart_count);
      var data = {};
      data[index] = cart_temp;
      let current_url = window.location.origin;
      // postFormDataAsJson(current_url+'/cart_react/add_to_cart', data);
      // var isloggedin = localStorage.getItem('cart_user_session');
      postFormDataAsJson(current_url + '/api/cart_react/add_to_cart', data);
      if (loggedInUser.is_logged_in) {
        var data = {};
        data[index] = cart_temp;
        postFormDataAsJson(current_url + '/api/cart_react/add_to_cart', data);
      }
      dispatch(setCart({ cartCount: cart_count }));
      // setCartText(true);
      // if (loggedInUser.is_logged_in) {
      //   var data = {};
      //   data[index] = cart_temp;
      //   postFormDataAsJson(current_url + '/cart_react/add_to_cart', data);
      // }
      window.location.href = '/cart_react';
      // if (item) {
      //  setCartText(true);
      // $(item).addClass("go-to-cart");
      // // $(item).addClass("theme-blue-btn2");
      // // $(item).removeClass("theme-blue-btn1");
      // $(item).text("Go to Cart");
      // $(item).attr("onclick", "goToCart()");
      // $('.cart-sec #cart_count').text(cart_count);
      // $(".cart-notification").removeClass("show");
      // $(".cart-notification").addClass("show");
      // setTimeout(function () {
      // 	$('.cart-notification.show').removeClass("show");
      // }, 3000);
      //}
    }
    navigate('/cart_react');
  };

  const BuyNowfn = (item = false, id, item_type, learners = [], other = {}) => {
    let ppsEnabled = 0;
    let bookingStatus = '1';
    let slug = '';
    var index = item_type + '_' + id;
    let current_url = window.location.origin;
    let isGuestEnabled = '';
    if (
      (typeof loggedInUser.logged_in_user.id != 'undefined' &&
        loggedInUser.logged_in_user.id != '') ||
      isGuestEnabled == '1'
    ) {
      window.location = current_url + '/cart_react?item=' + index;
    }

    // if((typeof(loggedUserid) != 'undefined' && loggedUserid != '') || isGuestEnabled == '1'){
    // 	window.location = site_url+'cart_react?item='+index;
    // } else {
    //     afterLoginCallBack = {
    //         callback : 'buyNow',
    //         id : id,
    //         type : item_type,
    //         slug : slug,
    //         ppsEnabled : ppsEnabled,
    //         bookingStatus : bookingStatus
    //     };
    //     let url = site_url+'cart_react?item='+index;
    //     window.location = __site_url + 'login'+'?redirect_url='+encodeURIComponent(url);
    //     // $('#sign-in').modal('show');

    //     set_cookies(__memcacheKey+'redirect_url', url, (300));
    // }
  };

  const languagefn = (language) => {
    let listLanguage = [];
    if (language && language.length == 1) {
      listLanguage = language[0]['cl_lang_name'];
    } else {
      listLanguage = language && language.map((lang) => lang.cl_lang_name);
    }
    let listLanguagestring = listLanguage && listLanguage.toString();
    return listLanguagestring;
  };

  const enquirefn = (coursedetails, itemType) => {
    navigate(`/enquiry?name=${encodeURIComponent(coursedetails?.bundle?.c_title)}&type=${itemType == "booking_event" ? "event" : encodeURIComponent(itemType)}&id=${encodeURIComponent(coursedetails?.bundle_id)}`)
  }
  const disableCartbutton = coursedetails?.cart_self_enroll;
  return (
    <div className="addtocart-block-wrapper">
      <div className={`${className || ''} carousel-block p-0`}>
        <div className="img-carousel">
          <img
            src={imagePath}
            className="img-fluid"
            alt="course-image"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = defaultImage;
            }}
          />
        </div>

        <div className="desc-carousel">
          {coursedetails?.bundle.c_price_label == 1 && (
            <div className="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
              {coursedetails?.bundle.c_is_free != '1' && (
                <div className="pricing-slot pricing-left">
                  <span>{miscellaneous.current_pricing_label}</span>
                  <div className="price">
                    {coursedetails && current_price_fn()}
                    <span>{coursedetails && discount_price_fn()}</span>
                  </div>
                  {/* <div className="price">Free</div> */}
                </div>
              )}
              <span className="separtor-price-set"></span>
              {coursedetails?.bundle.c_is_free != '1' &&
                coursedetails?.bundle.c_member_status == '1' && (
                  <div className="pricing-slot pricing-right">
                    <span>{miscellaneous.member_pricing_label}</span>
                    <div className="price">
                      {' '}
                      {coursedetails && member_price_fn()}
                      {/* <span>₹229</span> */}
                    </div>
                  </div>
                )}
            </div>
          )}

          {coursedetails?.bundle.c_price_label == 1 &&
          coursedetails?.bundle.c_is_free != '1' ? (
            coursedetails?.bundle.c_tax_method == 0 ? (
              <p className="exclusive-info">Inclusive of all taxes*</p>
            ) : (
              <p className="exclusive-info">Exclusive of all taxes*</p>
            )
          ) : (
            ''
          )}
          <div className="rating-cart-wrapper pt-0 border-0">
            {/* <Button
              variant="outline"
              className="w-100 mb-3"
              size="md"
              onClick={() => addToCartFn(false,coursedetails?.course.id,"course")}
            >
              Add to cart
            </Button> */}
            {disableCartbutton == 1 &&
              shopping_cart == 1 &&
              coursedetails?.bundle.c_is_free != 1 &&
              <AddToCartButton itemId={coursedetails?.bundle_id} itemType='bundle' />}

            {disableCartbutton == 1 &&
              (coursedetails?.bundle.c_is_free == 1 ? (
                <EnrollNowButton variant="outline" itemType={"bundle"} itemId={coursedetails?.bundle_id} className="w-100 mb-3"/>
              ) : (
                <Button
                  variant="secondary"
                  className="w-100 mb-3"
                  size="md"
                  onClick={() =>
                    BuyNowfn(false, coursedetails?.bundle_id, 'bundle')
                  }
                >
                  Buy now
                </Button>
              ))}

            {coursedetails?.bundle.c_enquiry_needed == 1 && (
              <Button
                variant="outline"
                className="w-100 border-0 mb-0"
                size="md"
                onClick={() => enquirefn(coursedetails, 'bundle')}
              >
                {chatIcon} Enquire Now
              </Button>
            )}
          </div>
          <div className="course-inclusion pt-3 mt-3">
            <h1>This Bundle includes:</h1>
            <ul>
            <li className="d-flex align-items-center gap-1 mb-2">
                {boxOIcon}
                <span>{coursedetails?.course_count} Courses</span>
              </li>
              <li className="d-flex align-items-center gap-1 mb-2">
                {boxOIcon}
                <span>{coursedetails?.training_courses_count} Training Courses</span>
              </li>
              <li className="d-flex align-items-center gap-1 mb-2">
                {boxOIcon}
                <span>{coursedetails?.training_events_count} Training Events</span>
              </li>
              <li className="d-flex align-items-center gap-1 mb-2">
                {documents}
                <span>{allLeactureCount} {allLeactureCount == 1 ? "Lecture" : "Lectures"}</span>
              </li>
              {/**
              <li className="d-flex align-items-center gap-1 mb-2">
                {awardIcon}
                <span>Certified course</span>
              </li>
              <li className="d-flex align-items-center gap-1">
                {globeIcon}
                <span>{languagefn(coursedetails?.course.cb_language)}</span>
              </li>
               */}
            </ul>
          </div>
        </div>
      </div>
      {/* <div className="addtocart-bottom-info">
        <h1>Get Subscription</h1>
        <p>Expert-led courses across a variety of online class topics for every step of your career. Instructors with real-world experience.</p>
        <Button
          variant="primary"
          className="w-100 mb-0"
          size="md"
        >
          Start my 1-month free trial
        </Button>
      </div> */}
    </div>
  );
}
export default AddToCartVerticalBundle;
